<div class="generalPage" *ngIf="pageinitiated">
  <div class="p-6 pr-22 effectivedate-content">
    <h1 class="top-heading content-blue mb-3-5" role="heading" aria-level="2">{{ed_header}}</h1>
    <article class="answer font-32 content-blue width-100 mb-2 bold">{{ed_suheader}}</article>
    <article class="answer font-16 content-blue width-100" [innerHTML]="ed_body"></article>

  </div>
  <div class="p-6 pr-22 effectivedate-content">
    <mat-accordion [multi]="false" class="p-6 pr-22 content-container">
      <mat-expansion-panel *ngFor="let item of accordion">
        <mat-expansion-panel-header class="mataccordianHeader ml-1" (click)="foucusaccordian($event)">
          <div class="matheadertext underline" [innerHTML]="item.title" ></div>
        </mat-expansion-panel-header>

        <article class="para-content font-16" [innerHTML]="item.content"></article>

      </mat-expansion-panel>
    </mat-accordion>




  </div>
  <div *ngFor="let item of ContentList" class="p-6 pr-22 effectivedate-content">
    <h1 class="para-content font-24" role="heading" aria-level="2">{{item.title}}</h1>
    <article class="answer font-16 content-blue width-100" [innerHTML]="item.content"></article>
    <br />

  </div>
</div>

